import { ExternalReportsComponent } from './external-reports.component'
import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { Routes } from '@angular/router'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { NgxPermissionsGuard } from 'ngx-permissions'

export const externalReportsRoutes: Routes = [
  {
    path: 'external-reports',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [{ path: '', component: ExternalReportsComponent }],
  },
]
